// store/index.js
import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import home from "./modules/home";
// 引用modules模块
import modules from "./modules/modules";
import dataCache from "./modules/dataCache";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user, // 注册用户模块
    home,//注册首页相关模块
    modules,//注册模块模块
    dataCache
  },
});
